var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Período de Formação ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('sigfoco-date-picker', {
    attrs: {
      "label": "Início do Período*",
      "removeIcon": "",
      "dataEdicao": _vm.content.dataInicio,
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }, function () {
        return _vm.validateData() || 'A data de início do período não pode ser posterior à data de fim e o período deve ter pelo menos 3 dias.';
      }]
    },
    model: {
      value: _vm.content.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataInicio", $$v);
      },
      expression: "content.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "label": "Fim do Período*",
      "removeIcon": "",
      "dataEdicao": _vm.content.dataFim,
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }, function () {
        return _vm.validateData() || 'A data de fim do período não pode ser posterior à data de inicio e o período deve ter pelo menos 3 dias.';
      }]
    },
    model: {
      value: _vm.content.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataFim", $$v);
      },
      expression: "content.dataFim"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.listPerfis,
      "item-text": 'nome',
      "item-value": 'id',
      "rules": [function (p) {
        return p.some(function (v) {
          return _vm.$required(v);
        }) || 'Campo obrigatório';
      }],
      "label": "Perfil*",
      "multiple": "",
      "outlined": "",
      "dense": "",
      "return-object": ""
    },
    model: {
      value: _vm.content.perfis,
      callback: function ($$v) {
        _vm.$set(_vm.content, "perfis", $$v);
      },
      expression: "content.perfis"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }